import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import * as Icon from 'react-feather';
import FormInput from '../../components/form/FormInput';
import FormTextarea from '../../components/form/FormTextarea';
import { convertToMask } from '../../utils/common';
import { useUserDetails } from '../../store/slices/authSlice';
import whatsappIcon from '../../assets/images/icons/whatsapp.svg';
import useWhatsappHandoff from '../../hooks/useWhatsappHandoff';
import { useTranslation } from 'react-i18next';
import { CRM_COMMENT_ROWS } from '../../utils/crmLayout';

const Information = ({ data, onUpdate, onSubmit }) => {
  const { t } = useTranslation();
  const user = useUserDetails();
  const handleWhatsappClick = useWhatsappHandoff();

  const [comment, setComment] = useState(data?.comment || ''); // Initialize with data.comment if available

  useEffect(() => {
    if (onUpdate) {
      onUpdate({ ...data, comment });
    }
  }, [comment]);

  const onCallNumber = (number, numberType) => {
    if (!number) return;
    onSubmit?.({ pendingDial: { number, numberType } });
  };

  const callIcon = (number, numberType) => {
    if (!user?.manualcall) return null;
    const enabled = Boolean(number);
    return (
      <Icon.PhoneCall
        size={18}
        className={enabled ? 'cursor-pointer text-primary' : 'text-muted'}
        style={enabled ? undefined : { cursor: 'not-allowed', opacity: 0.5 }}
        onClick={enabled ? () => onCallNumber(number, numberType) : undefined}
      />
    );
  };

  return (
    <Row>
      <Col xs="4">
        <FormInput
          label={t('primaryNumber')}
          name="primaryNumber"
          isIcon={user?.userWhatsappPermission}
          icon={
            <img
              src={whatsappIcon}
              width={20}
              height={20}
              className="cursor-pointer"
              onClick={() => handleWhatsappClick(data?.primaryNumber)}
            />
          }
          value={
            user?.process_details?.numberMasking === 'true'
              ? convertToMask(data?.primaryNumber)
              : data?.primaryNumber
          }
          disabled
        />
      </Col>
      <Col xs="4">
        <FormInput
          label={t('secondaryNumber')}
          name="secondaryNumber"
          isIcon={Boolean(user?.manualcall)}
          icon={callIcon(data?.secondaryNumber, 'secondary')}
          value={
            user?.process_details?.numberMasking === 'true'
              ? convertToMask(data?.secondaryNumber)
              : data?.secondaryNumber
          }
          disabled
        />
      </Col>
      <Col xs="4">
        <FormInput
          label={t('tertiaryNumber')}
          name="tertiaryNumber"
          isIcon={Boolean(user?.manualcall)}
          icon={callIcon(data?.tertiaryNumber, 'tertiary')}
          value={
            user?.process_details?.numberMasking === 'true'
              ? convertToMask(data?.tertiaryNumber)
              : data?.tertiaryNumber
          }
          disabled
        />
      </Col>
      <Col xs="12">
        <FormTextarea
          label={t('comment')}
          name="comment"
          value={comment}
          rows={CRM_COMMENT_ROWS}
          placeholder={t('enterComment')}
          onChange={(e) => setComment(e.target.value)}
        />
      </Col>
    </Row>
  );
};

Information.propTypes = {
  data: PropTypes.object,
  onUpdate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func
};

export default Information;
